import { jasBoardVerificationHistoryStatusSchema } from '../../../../backend/features/jas-boards/shared';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Info from '@mui/icons-material/Info';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Stack, Typography } from '@mui/material';
import React from 'react';
export const JasBoardStatusLabelIcon = ({ status }) => {
    const { t } = useCredentialingTranslation();
    const result = jasBoardVerificationHistoryStatusSchema.safeParse(status);
    if (!result.success)
        return null;
    return (React.createElement(Stack, { spacing: 1, direction: 'row', alignItems: 'center' },
        React.createElement(JasBoardStatusIcon, { status: result.data }),
        React.createElement(Typography, { variant: 'body2' }, t(`table.jasBoardStatusHistory.status.${result.data}`))));
};
export const JasBoardStatusIcon = ({ status }) => {
    switch (status) {
        case 'active':
            return React.createElement(CheckCircleIcon, { htmlColor: themeColors.accent.green.base });
        case 'failed':
            return React.createElement(RemoveCircleIcon, { htmlColor: themeColors.accent.red.base });
        case 'inactive':
            return React.createElement(CancelIcon, { htmlColor: themeColors.accent.grey.base });
        case 'outOfDate':
            return React.createElement(Info, { htmlColor: themeColors.accent.blue.base });
        default:
            return null;
    }
};
